import { Grid, Typography, Box } from '@mui/material';
import { useMemo } from 'react';
import { FileUpload } from 'shared/controls/file-upload';
import { useWatch } from 'react-hook-form';
import { IAdditionalQuoteDocumentationItem, IQuoteDocumentation, IQuoteDocument } from 'shared/types';
import { useAdditionalQuoteDocumentationTableInstance } from './quote-review/tables/additional-quote-documentation-table-instance';
import { AdditionalQuoteDocumentationTable } from './quote-review/tables/additional-quote-documentation-table';

interface Props {
  quote?: Partial<IQuoteDocument>;
  disabled?: boolean;
}

export const QuoteDocumentation = ({ quote, disabled }: Props) => {
  const currentQuoteFilesToDelete = useWatch({ name: 'quoteFilesToDelete' }) as IQuoteDocumentation[];

  const currentQuoteFilesToDeleteLength = currentQuoteFilesToDelete?.length;
  const tableData: IAdditionalQuoteDocumentationItem[] = useMemo(() => {
    const quoteIdsMarkedForDeletion = !!currentQuoteFilesToDelete ? currentQuoteFilesToDelete.map(q => q.id) : [];
    const quoteFilesNotMarkedForDeletion = !!quote?.quoteDocumentation
      ? !!currentQuoteFilesToDeleteLength
        ? [...quote.quoteDocumentation.filter(q => !quoteIdsMarkedForDeletion.includes(q.id))]
        : [...quote?.quoteDocumentation]
      : [];
    return quoteFilesNotMarkedForDeletion;
  }, [quote?.quoteDocumentation, currentQuoteFilesToDelete, currentQuoteFilesToDeleteLength]);

  const additionalQuoteDocumentationTableInstance = useAdditionalQuoteDocumentationTableInstance(tableData);

  return (
    <Grid item container>
      <Grid xs={12} item container spacing={1}>
        <Grid xs={12} md={3} item>
          <Box sx={{ display: 'flex', flexFlow: 'row' }}>
            <Typography variant='subtitle1' sx={{ fontWeight: 'bold' }}>
              Quote Documentation
            </Typography>
          </Box>
        </Grid>
        <Grid xs={12} md={9} item>
          <Box sx={{ display: 'flex', flexFlow: 'row' }}>
            <Typography variant='subtitle1' sx={{ fontWeight: 'bold' }}>
              Previously Uploaded Files
            </Typography>
          </Box>
        </Grid>
        <Grid xs={12} md={3} item>
          <FileUpload disabled={disabled} name={'files'} isMultiple accept={'application/pdf'} />
        </Grid>
        <Grid xs={12} md={9} item>
          <AdditionalQuoteDocumentationTable instance={additionalQuoteDocumentationTableInstance} />
        </Grid>
      </Grid>
    </Grid>
  );
};
